import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import RoleRequire from "@/helpers/auth/RoleRequire";
import { AdminSensorsTable } from "@/types/formDataTypes";
import { Button } from "@/ui/Button";
import { Input } from "@/ui/Input/Input";
import { ColumnDef } from "@tanstack/react-table";
import { MenuDataTable } from "@/ui/DataTable/MenuDataTable";
import { AdminSensorType } from "@/types/types";

export default function SensorsGrid({
  sensors,
  onClose,
}: {
  sensors: AdminSensorType[];
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  let nodes = sensors?.map((data) => {
    return {
      id: String(data.id),
      name: data.attributes.name,
      short_name: data.attributes.short_name,
      long_name: data.attributes.long_name,
      data_key_name: data.attributes.data_key_name,
      chart_type: data.attributes.chart_type,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) =>
      search ? item.name?.toLowerCase().includes(search.toLowerCase()) : true,
    ),
  };

  const columns: ColumnDef<AdminSensorsTable>[] = [
    {
      header: t("name"),
      size: 200,
      minSize: 200,
      maxSize: 200,
      cell: ({ row }) => row.original.name,
    },
    {
      header: t("long_name"),
      size: 400,
      minSize: 400,
      maxSize: 400,
      cell: ({ row }) => row.original.long_name,
    },
    {
      header: t("short_name"),
      size: 200,
      minSize: 200,
      maxSize: 200,
      cell: ({ row }) => row.original.short_name,
    },
    {
      header: t("data_key_name"),
      size: 200,
      minSize: 200,
      maxSize: 200,
      cell: ({ row }) => row.original.data_key_name,
    },
    {
      header: t("chart_type"),
      size: 200,
      minSize: 200,
      maxSize: 200,
      cell: ({ row }) => row.original.chart_type,
    },
  ];

  function selectSensor(sensor: any) {
    onClose();
  }

  function addAdminSensor() {
    navigate("/admin/sensors/new");
    onClose();
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
          <Input
            className="h-8"
            placeholder={t("search")}
            onChange={handleSearch}
            value={search}
            autoComplete="off"
            width="100%"
          />

          <RoleRequire role="maintainer">
            <Button
              variant={"default"}
              size={"md"}
              onClick={() => addAdminSensor()}
            >
              {t("add")}
            </Button>
          </RoleRequire>
        </div>
      </div>

      {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
          {t("no_data")}
        </div>
      ) : (
        <MenuDataTable
          route="/admin/sensors"
          data={data.nodes}
          columns={columns}
          onClickRow={selectSensor}
        />
      )}
    </>
  );
}
